import { Grid, Typography } from "@mui/material";
import React from "react";
import { orderStatusFormatted } from "src/constant";
import useAuthGlobal from "src/context/useAuthGlobal";
import useOrderSummary from "src/hooks/orders/useOrderSummary";
import useQueryParams from "src/hooks/useQueryParams";
const statusText = { fontSize: "12px" };
export default function OrderSummary() {
  const { userMe } = useAuthGlobal();

  const [option] = useQueryParams();
  const { data: order } = useOrderSummary({
    warehouse: option?.whouseId ?? userMe?.currentWarehouse?._id,
  });

  return (
    <Grid
      container
      sx={{
        background: "var(--light-grey)",
        borderRadius: "6px",
      }}
    >
      {/* <Grid
        xs={12}
        item
        container
        spacing={2}
        p="24px 12px 12px"
      >
        <Grid
          xs={12}
          item
        >
          <Typography>
            Thống kê trạng thái đơn hàng từ <strong>KÊNH</strong>
          </Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          item
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.salesChannel?.Pending ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Chờ xác nhận</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          item
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.salesChannel?.WaitToExport ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Chờ xuất hàng</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          item
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.salesChannel?.ReadyToPick ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Chờ lấy hàng</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          item
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.salesChannel?.Delivering ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Đang vận chuyển</Typography>
        </Grid>
      </Grid> */}
      <Grid
        xs={12}
        item
        container
        spacing={2}
        p="24px 12px"
      >
        <Grid
          xs={12}
          item
        >
          <Typography fontWeight="bold">Thống kê trạng thái đơn hàng từ KHO</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          sx={{ pt: "4px !important" }}
          item
          textAlign="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.warehouse[orderStatusFormatted.WaitToExport] ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Chờ xuất hàng</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          sx={{ pt: "4px !important" }}
          item
          textAlign="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.warehouse[orderStatusFormatted.ReadyToPick] ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Chờ lấy hàng</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          sx={{ pt: "4px !important" }}
          item
          textAlign="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.warehouse[orderStatusFormatted.Delivering] ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Đang giao</Typography>
        </Grid>
        <Grid
          xs={12 / 4}
          sx={{ pt: "4px !important" }}
          item
          textAlign="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="24px"
          >
            {order?.data?.warehouse[orderStatusFormatted.DeliveredFailed] ?? 0}
          </Typography>
          <Typography sx={{ ...statusText }}>Giao không thành công</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
